/**
 * Question type distribution and selection utilities.
 */
import { QUESTION_TYPES } from '../../constants/subjects';
export const DIFFICULTY_QUESTION_TYPE_DISTRIBUTION = {
    easy: {
        [QUESTION_TYPES.MULTIPLE_CHOICE]: 0.5,
        [QUESTION_TYPES.TRUE_FALSE]: 0.3,
        [QUESTION_TYPES.SHORT_ANSWER]: 0.15,
        [QUESTION_TYPES.OPEN_ENDED]: 0.03,
        [QUESTION_TYPES.SCENARIO_BASED]: 0.02,
    },
    medium: {
        [QUESTION_TYPES.MULTIPLE_CHOICE]: 0.35,
        [QUESTION_TYPES.TRUE_FALSE]: 0.2,
        [QUESTION_TYPES.SHORT_ANSWER]: 0.25,
        [QUESTION_TYPES.OPEN_ENDED]: 0.15,
        [QUESTION_TYPES.SCENARIO_BASED]: 0.05,
    },
    hard: {
        [QUESTION_TYPES.MULTIPLE_CHOICE]: 0.2,
        [QUESTION_TYPES.TRUE_FALSE]: 0.1,
        [QUESTION_TYPES.SHORT_ANSWER]: 0.3,
        [QUESTION_TYPES.OPEN_ENDED]: 0.25,
        [QUESTION_TYPES.SCENARIO_BASED]: 0.15,
    },
};
export function getQuestionTypeDistribution(difficulty) {
    return DIFFICULTY_QUESTION_TYPE_DISTRIBUTION[difficulty] || DIFFICULTY_QUESTION_TYPE_DISTRIBUTION['medium'];
}
export function selectRandomQuestionType(difficulty) {
    const distribution = getQuestionTypeDistribution(difficulty);
    const random = Math.random();
    let cumulative = 0;
    for (const [questionType, probability] of Object.entries(distribution)) {
        cumulative += probability;
        if (random <= cumulative) {
            return questionType;
        }
    }
    return QUESTION_TYPES.MULTIPLE_CHOICE;
}
